module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacidad",
	"footer.privacy.url": "https://www.grohe.es/es_es/privacidad.html",
	"footer.disclaimer.text": "Declinación de responsabilidad",
	"footer.disclaimer.url": "https://www.grohe.es/es_es/imprimir.html",
	"footer.copyright": "&copy; 2018 Grohe España, S.A",
	"homepage.headline": "Configurador de sistemas de agua GROHE",
	"homepage.introtext": "Para configurar el sistema de agua GROHE que se adapta mejor a tus necesidades, solo tienes que responder a continuación a unas cuantas preguntas.",
	"homepage.buttonStart": "Empezar",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Pagina no encontrada",
	"404.link.goBack": "Volver a la página de inicio",
	"configurator.button.seeResults": "Ver los resultados",
	"question1.question": "¿En la cocina tienes suministro de agua fría y caliente?",
	"question1.option1.text": "En la cocina tengo suministro de agua fría y caliente",
	"question1.option2.text": "Solo tengo suministro de agua fría",
	"question2.question": "¿Qué tipo de agua estás buscando?",
	"question2.option1.text": "Agua hirviendo para preparar bebidas y la comida",
	"question2.option2.text": "Agua muy fría y con gas para beber",
	"question2.option3.text": "Agua muy fría y con gas para beber y también agua hirviendo",
	"question3.question": "¿Quieres conservar tu grifo de cocina actual?",
	"question3.option1.text": "Quiero conservarlo",
	"question3.option2.text": "Quiero instalar un modelo nuevo",
	"question4.question": "¿Cuál será tu grifo principal?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "¿Qué diseño de caño prefieres?",
	"question5.option1.text": "Caño con forma en L",
	"question5.option2.text": "Caño con forma en U",
	"question5.option3.text": "Caño con forma en C",
	"question6.question": "¿Qué acabado prefieres?",
	"question6.option1.text": "Chrome",
	"question6.option2.text": "Supersteel",
	"question7.question": "¿Qué tamaño de calentador necesitas?",
	"question7.option1.text": "Tamaño M (3 litros)",
	"question7.option2.text": "Tamaño L (5,5 litros)",
	"results.title": "{productGroupsCount, plural, \none {Tu resultado} \nother {Tus resultados}\n}",
	"results.proposal.title": "Propuesta {number}",
	"results.proposal.title.single": "Propuesta",
	"results.bundle.title": "Para una instalación correcta, también necesitarás:",
	"results.newConfiguration.title": "¿Quieres configurar un nuevo sistema de agua?",
	"results.newConfiguration.buttonText": "Configura un sistema de agua nuevo",
	"results.product.number": "Número de producto: #{number}",
	"results.product.button.productInformation": "Información del producto",
	"results.product.button.dealerLocator": "Encuentra un punto de exposición y venta",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Información del producto",
	"results.product.dealer": "Encuentra un punto de exposición y venta",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.es_es.json
// module id = 770
// module chunks = 0